import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { map, take } from 'rxjs';
// import { TokenService } from '../services/token.service';

export const authGuard: CanActivateFn = (route, state) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);  

  tokenService.isAuthentication.subscribe({
    next:(value) =>{
      if(value) {      
      } else {
        router.navigateByUrl('pub/login');
      }
    }
  })
  return true;
};
